import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getPatients = asyncThunkWrapper({ 
  model: 'patients', 
  action: 'getPatients', 
  func: async ({ offset = 0, query = null, source = null }) => {
    const attributes = [
      'id', 
      { clinic: ['name'] },
      'first_name',
      'last_name',
      'gender',
      'birth_at',
      'phone', 
      'email',
      'source',
      'language',
      'street_address',
      'city',
      'state',
      'zip',
      'updated_at'
    ];
    const params = { limit: 25, offset, orders: { updated_at: 'desc' }, attributes, ...(query && { query }), ...(source && { source }) };
    const response = await axios.get('/patients', { params });

    return { data: response.data, source };
  } 
});
export const getPatient = asyncThunkWrapper({ 
  model: 'patients', 
  action: 'getPatient', 
  func: async ({ id, cable = false }) => {
    const attributes = [
      'id', 
      { clinic: ['name'] },
      'first_name',
      'last_name',
      'gender',
      'birth_at',
      'phone', 
      'email',
      'source',
      'language',
      'street_address',
      'city',
      'state',
      'zip',
      'updated_at'
    ];
    const params = { attributes };
    const response = await axios.get(`/patients/${id}`, { params });

    return { data: response.data, cable };
  } 
});
export const createPatient = asyncThunkWrapper({ 
  model: 'patients', 
  action: 'createPatient', 
  func: async ({ patient }) => {
    const attributes = [
      'id', 
      { clinic: ['name'] },
      'first_name',
      'last_name',
      'gender',
      'birth_at',
      'phone', 
      'email',
      'source',
      'language',
      'street_address',
      'city',
      'state',
      'zip',
      'mode',
      'trigger',
      'orchestrate',
      'updated_at'
    ];
    const response = await axios.post(`/patients`, { patient, attributes });

    return response.data;
  } 
});
export const updatePatient = asyncThunkWrapper({ 
  model: 'patients', 
  action: 'updatePatient', 
  func: async ({ id, ...fields }) => {
    const response = await axios.patch(`/patients/${id}`, { patient: { ...fields } });

    return { status: response.status, patient: { ...fields } };
  } 
});
export const deletePatient = asyncThunkWrapper({ 
  model: 'patients', 
  action: 'deletePatient', 
  func: async (id) => {
    const response = await axios.delete(`/patients/${id}`);

    return { status: response.status, id };
  } 
});
export const deleteLocalPatient = createAction('patients/deleteLocalPatient');
export const clearLocalPatients = createAction('patients/clearLocalPatients');
export const clearLocalActivePatient = createAction('patients/clearLocalActivePatient');